import { Route, Routes } from "react-router-dom";
import AddCostumer from "./add-costumer/add-costumer.component";
import EditCostumer from "./edit-costumer/edit-costumer.component";
import { PendingPericiasPage } from "../../pages/pericia/list-pericias-by-costumer";
import ListCostumersPage from "../../pages/costumer/list-costumers.page";
import ListCostumerPericiasPage from "../../pages/pericia/list-pericias-by-costumer-id.page";
import { ACCESS_RULES } from "../../shared/auth/access-control";
import RoleProtectedRoute from "../protected/role-protected-route.component";

const CostumersRoutes = () => {
  return (
    <Routes>
      <Route path="/add" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.COSTUMERS_CREATE}><AddCostumer /></RoleProtectedRoute>} />
      <Route path="/list" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.COSTUMERS_LIST}><ListCostumersPage /></RoleProtectedRoute>} />
      {/* <Route path="/list/pericias2" element={<ListPericias />} /> */}
      <Route path="/list/pericias" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.COSTUMERS_LIST}><ListCostumerPericiasPage /></RoleProtectedRoute>} />
      <Route path="/list/pericias/pending" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.REPORTS}><PendingPericiasPage /></RoleProtectedRoute>} />
      <Route path=":costumerID" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.COSTUMERS_EDIT}><EditCostumer /></RoleProtectedRoute>} />
    </Routes>
  );
};

export default CostumersRoutes;
